import Model from 'cdna/core/model';
import GuideEntryCollection from './guideEntryCollection.js';

export default Model.extend({
    defaults: {
        Title: 'Guides',        
        Entries: [],
        isActive: false,
        canPrint: false
    },
    modelTypes: {
        Entries: GuideEntryCollection
    }
});



/** WEBPACK FOOTER **
 ** ./client/guide/guidePageModel.js
 **/